import { PageHeader } from 'antd';
import { useAppSelector } from 'app/hooks';
import { useTranslation } from 'react-i18next';
import { ResellerCertificateAdminTable } from './ResellerCertificateAdminTable';
import { ResellerCertificateForm } from './ResellerCertificateForm';

const ResellerCertificateAdminContainer = () => {
  const { t } = useTranslation();
  const curItem = useAppSelector((state) => state.resellerCertificate.curItem);
  return (
    <>
      <PageHeader
        ghost={false}
        title={t('platform.header.resellerCertificate')}
        className="platform-page-header"
        extra={
          [
            // <RevxButton
            //   key="create"
            //   disabled={!!curItem}
            //   brandGreen
            //   onClick={() => {
            //     dispatch.account.setState({
            //       curItem: {
            //         siteRole: SiteRoleEnum.NoSiteAccess,
            //         platformRole: PlatformRoleEnum.NoAdminAccess,
            //       },
            //     });
            //   }}
            // >
            //   {t('platform.account.createUserAccount')}
            // </RevxButton>,
          ]
        }
      />
      {curItem && <ResellerCertificateForm />}
      <ResellerCertificateAdminTable />
    </>
  );
};

export default ResellerCertificateAdminContainer;
